module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ResultsTable1', {
    attrs: {
      "samples": _vm.samples
    }
  }), _vm._v(" "), _c('ResultsTable2', {
    attrs: {
      "samples": _vm.samples
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-fa10ed56!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/online-soil-report/Results.vue
// module id = DatD
// module chunks = 0